import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import iotDeviceConfig from '../../../services/iotDevice/iotDeviceConfig';
import {refreshFeaturesConfigDate} from '../../../state/ducks/iotDevice/actions';
import {selectIotDeviceData} from '../../../state/selectors/iotDevice';
import {
    makeSelectIsYapDeviceInfoReceived,
    makeSelectIsYapHolderInfoReceived,
} from '../../../state/selectors/yapEncrypted';
import {dispatch} from '../../../state/store';

const useIotDeviceConfigReset = () => {
    const iotDevice = useSelector(selectIotDeviceData);
    const {device} = iotDevice || {};
    const {isHolderConnected} = device || {};
    const isYapDeviceInfoReceived = useSelector(makeSelectIsYapDeviceInfoReceived());
    const isYapHolderInfoReceived = useSelector(makeSelectIsYapHolderInfoReceived());
    const isYapHolderReady = isHolderConnected ? isYapHolderInfoReceived : true;
    const isReady = isYapDeviceInfoReceived && isYapHolderReady;

    useEffect(() => {
        if (!isReady) return;

        iotDeviceConfig.resetManagementFeaturesConfig(iotDevice);
        dispatch(refreshFeaturesConfigDate());
    }, [isHolderConnected, isReady]);
};

export default useIotDeviceConfigReset;
